import { baseAPI } from "../baseApi";

export const transportApiSlice = baseAPI.injectEndpoints({
    endpoints: builder => ({
        getTransport: builder.query<any, any>({
            query: () => ({
                url: `transport/get`
            })
        }),
        getTransportById: builder.query<any, any>({
            query: ({ id }) => ({
                url: `transport/get?id=${id}`
            })
        }),
        getTransportDrivewaysList: builder.query<any, any>({
            query: () => ({
                url: `transport/driveways/list`
            })
        }),
        getDrivewaysByTransportId: builder.query<any, any>({
            query: ({ lon, lat, transportId, date }) => ({
                url: `transport/driveways/get?lon=${lon}&lat=${lat}&objectId=${transportId}&date=${date}`
            })
        })
    })
})

export const {
    useGetTransportQuery,
    useGetTransportByIdQuery,
    useGetTransportDrivewaysListQuery,
    useGetDrivewaysByTransportIdQuery
} = transportApiSlice